exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3McSMeYD3GCmW6gnMM6Oku{color:\"[theme:themePrimary, default:#0078D4]\"}._21wja-HiOMg0pkC7BOR77c{font-weight:400;font-size:14px}html[dir=ltr] ._21wja-HiOMg0pkC7BOR77c{padding-left:3px}html[dir=rtl] ._21wja-HiOMg0pkC7BOR77c{padding-right:3px}", ""]);

// exports
exports.locals = {
	"reservationStatus": "_3McSMeYD3GCmW6gnMM6Oku",
	"reservationStatusText": "_21wja-HiOMg0pkC7BOR77c"
};